<template>
<div class="item" @click="showDetail(recommendItem.id)">

<el-row>
  <el-col :span="10"><img :src="recommendItem.coverUrl" height="100px"></el-col>
  <el-col :span="14"><div class="van-multi-ellipsis--l2" style="margin-left: 3%;">
        {{recommendItem.details}}
        </div></el-col>
</el-row>

    
</div>
</template>

<script>
export default {
    name:'PcRecommendListItem',
    props:{
        recommendItem:{
            type:Object,
            default(){
                return {}
            }
        }
    },
    methods:{
        showDetail(id){
            // this.$router.push({
            //     path: "/share/"+id
            // });
            // this.$router.go(0);
            window.location.href = `/share/${id}`
        }
    }
}
</script>

<style scoped>
    .item{
       margin-bottom: 10px;
    }
    
    .item img{
        width: 100%;
        border-radius: 15px;
    }
</style>


// WEBPACK FOOTER //
// src/components/content/PcRecommendListItem.vue